const LIVE = ['needs_decision', 'task_created', 'task_in_progress']
const TASK_STAGES = ['task_created', 'task_in_progress']
const DAY_MS = 86400000

export const parseDateOnly = value => {
  if (!value) return null
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value))
  if (!match) return null
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
}

const startOfDay = now => new Date(now.getFullYear(), now.getMonth(), now.getDate())

export const daysUntil = (value, now = new Date()) => {
  const date = parseDateOnly(value)
  if (!date) return null
  return Math.round((date - startOfDay(now)) / DAY_MS)
}

export const formatDay = value => {
  const date = parseDateOnly(value)
  return date ? date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : ''
}

export const dueInfo = (action, now = new Date()) => {
  const stage = action?.stage
  const live = LIVE.includes(stage)
  const followsTask = TASK_STAGES.includes(stage) && (action?.taskSummary?.count ?? 0) > 0
  const date = action?.effectiveDueDate || action?.dueDate || null
  const days = daysUntil(date, now)
  const overdue = live && action?.isOverdue === true
  let label = null
  let level = null
  if (live && days !== null) {
    if (overdue) {
      label = days < 0 ? `Overdue by ${-days} day${days === -1 ? '' : 's'}` : 'Overdue'
      level = 'critical'
    } else if (days <= 0) {
      label = 'Due today'
      level = 'high'
    } else if (days <= 7) {
      label = days === 1 ? 'Due tomorrow' : `Due in ${days} days`
      level = 'medium'
    } else {
      label = `Due in ${days} days`
    }
  }
  return { date, days, label, level, overdue, followsTask, live }
}

const MINUTE_MS = 60000

const plural = (count, unit) => `${count} ${unit}${count === 1 ? '' : 's'} ago`

export const relativeTime = (value, now = new Date()) => {
  if (!value) return ''
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  const diff = now - date
  if (diff < MINUTE_MS) return 'just now'
  const minutes = Math.floor(diff / MINUTE_MS)
  if (minutes < 60) return plural(minutes, 'minute')
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return plural(hours, 'hour')
  const days = Math.round((startOfDay(now) - startOfDay(date)) / DAY_MS)
  if (days <= 1) return 'yesterday'
  if (days < 7) return plural(days, 'day')
  if (days < 30) return plural(Math.floor(days / 7), 'week')
  return `on ${date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}`
}
